import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { id: "house", label: "The House" },
  { id: "mussoorie", label: "Mussoorie" },
  { id: "experience", label: "Experience" },
  { id: "gallery", label: "Gallery" },
  { id: "extended", label: "Extended Stays" },
  { id: "amenities", label: "Amenities" },
  { id: "location", label: "Location" },
  { id: "faq", label: "FAQs" },
  { id: "contact", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#F7F5F0]/85 backdrop-blur-xl border-b border-[#2C392F]/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="nav-link-home"
          onClick={() => go("top")}
          className="flex items-baseline gap-2 group"
        >
          <span className="serif text-2xl md:text-[26px] tracking-tight text-[#2C392F]">ChiMano</span>
          <span className="text-[10px] uppercase tracking-[0.35em] text-[#985F47]">House</span>
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-[13px] tracking-wide text-[#1A1C1A]/80 hover:text-[#2C392F] transition-colors relative"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="cta-button-enquire-header"
            onClick={() => go("enquire")}
            className="hidden md:inline-flex items-center gap-2 bg-[#2C392F] text-[#F7F5F0] hover:bg-[#1E2823] px-5 py-3 rounded-full text-[12px] tracking-[0.18em] uppercase transition-all"
          >
            Enquire Now
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-[#2C392F] p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#F7F5F0] border-t border-[#2C392F]/10 px-6 py-6 space-y-3">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="block w-full text-left text-base text-[#1A1C1A] py-2 border-b border-[#2C392F]/5"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="cta-button-enquire-mobile-menu"
            onClick={() => go("enquire")}
            className="mt-2 w-full bg-[#2C392F] text-[#F7F5F0] py-3 rounded-full text-sm tracking-[0.18em] uppercase"
          >
            Enquire Now
          </button>
        </div>
      )}
    </header>
  );
}
